import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { combineLatest } from 'rxjs';
import { pluck } from 'rxjs/operators';
const secondHandSuppliesBidsSubscription = gql`subscription second_hand_supplies_bids(
  $second_hand_supplies_id: uuid!,
  $limit: Int,
  $offset: Int){
  second_hand_supplies_bids(
    where:{second_hand_supplies_id:{_eq: $second_hand_supplies_id}},
    limit: $limit,
    offset: $offset,
    order_by: {created_at: desc}
    ){
    id
    created_at
    updated_at
    second_hand_supplies_id
    type
    dental_supplier_id
    dental_supplier {
      id
      name
    }
    dental_professional_id
    dental_professional {
      id
      name
    }
    dental_practice_id
    dental_practice {
      id
      name
    }
    message
    price
    accepted_at
    accepted_message
  }
}`;

const secondHandSuppliesBidsAggregateSubscription = gql`subscription second_hand_supplies_bids_aggregate($second_hand_supplies_id: uuid!){
  second_hand_supplies_bids_aggregate(where:{second_hand_supplies_id:{_eq: $second_hand_supplies_id}}){
    aggregate {
      count
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSuppliesBidsService {

  constructor(private apollo: Apollo) { }


  getSecondHandSuppliesBids(filter: any){
    return combineLatest([

      this.apollo.use('external').subscribe({
        query: secondHandSuppliesBidsSubscription,
        variables: {
          second_hand_supplies_id: filter.second_hand_supplies_id,
          limit: filter.limit,
          offset: filter.offset
        }
      }).pipe(pluck('data', 'second_hand_supplies_bids')),

      this.apollo.use('external').subscribe({
        query: secondHandSuppliesBidsAggregateSubscription,
        variables:{
          second_hand_supplies_id: filter.second_hand_supplies_id
        }
      }).pipe(pluck('data', 'second_hand_supplies_bids_aggregate', 'aggregate', 'count'))

    ]);
  }
}
